import React from 'react'
import TerminalList from './List'

const State: React.FC = () => {
  return (<><TerminalList /></>)
}

export default State